module.exports = __webpack_public_path__ + "img/Entia-Infraestructura-Ferroviaria-8.0806a558.webp";